import React, { Component } from 'react';
import { Link as RouterLink, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import validate from 'validate.js';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { loginUserRequest } from '@redux/actions/AuthActions';

import { withStyles } from '@material-ui/core/styles';
import Logo from '@assets/images/logo.png';
import TwoFactor from './TwoFactor';
import { Button, TextField, Link, Typography } from '@material-ui/core';

import { styles } from './styles';

//TODO: Break smaller components
//TODO: export css in js
//TODO: hooks/class

const schema = {
  email: {
    presence: { allowEmpty: false, message: 'is required' },
    email: true,
    length: {
      maximum: 64
    }
  },
  password: {
    presence: { allowEmpty: false, message: 'is required' },
    length: {
      maximum: 128
    }
  }
};

class SignInComponent extends Component {
  state = {
    value: '',
    twoFactor: false,
    formState: {
      isValid: false,
      values: {},
      touched: {},
      errors: {}
    }
  };


  handleChange = event => {
    const { formState } = this.state;

    const errors = validate(formState.values, schema);

    event.persist();

    this.setState({
      formState: {
        ...formState,
        values: {
          ...formState.values,
          [event.target.name]: event.target.value
        },
        touched: {
          ...formState.touched,
          [event.target.name]: true
        },
        isValid: errors ? false : true,
        errors: errors || {}
      }
    });
  };

  handleLogin = event => {
    const { email, password } = this.state.formState.values;
    event.preventDefault();

    this.props.setUserLogin(email, password);

    // setTwoFactor(() => ({
    //   twoFactor: true
    // }));
  };

  handleSms = event => {
    event.preventDefault();
    this.props.history.push('/panel');
  };

  hasError = field => {
    const { formState } = this.state;
    return formState.touched[field] && formState.errors[field] ? true : false;
  };

  render() {
    const { twoFactor, formState } = this.state;
    const { classes } = this.props;

    return (
      <div className={classes.content}>
        <img alt="Praexo" className={classes.logo} src={Logo} />

        <div className={classes.contentBody}>
          {twoFactor ? (
            <form className={classes.form} onSubmit={this.handleSms}>
              <Typography color="textSecondary" gutterBottom>
                Enter the 6 digits code you received by email to log in.
              </Typography>
              <TwoFactor />
              <Button
                className={classes.signInButton}
                color="primary"
                //   disabled={!formState.isValid}
                size="large"
                type="submit"
                variant="contained">
                LOGIN
              </Button>

              <Typography
                style={{ color: '#d8d8d8', textDecoration: 'underline' }}>
                I haven't recived the code
              </Typography>
            </form>
          ) : (
            <form className={classes.form} onSubmit={this.handleLogin}>
              <TextField
                className={classes.textField}
                error={this.hasError('email')}
                fullWidth
                helperText={
                  this.hasError('email') ? formState.errors.email[0] : null
                }
                label="Email address"
                name="email"
                onChange={this.handleChange}
                type="text"
                value={formState.values.email || ''}
                variant="outlined"
              />
              <TextField
                className={classes.textField}
                error={this.hasError('password')}
                fullWidth
                helperText={
                  this.hasError('password')
                    ? formState.errors.password[0]
                    : null
                }
                label="Password"
                name="password"
                onChange={this.handleChange}
                type="password"
                value={formState.values.password || ''}
                variant="outlined"
              />
              <Button
                className={classes.signInButton}
                color="primary"
                disabled={!formState.isValid}
                size="large"
                type="submit"
                variant="contained">
                LOGIN
              </Button>
              <Typography color="textPrimary" variant="body1">
                Forgot your password?{' '}
                <Link component={RouterLink} to="/forgot" variant="h6">
                  Reset
                </Link>
              </Typography>
            </form>
          )}
        </div>
      </div>
    );
  }
}

SignInComponent.propTypes = {
  classes: PropTypes.any,
  history: PropTypes.object
};

export const mapStateToProps = state => ({ auth: state.auth });

export const mapDispatchToProps = dispatch => {
  return {
    setUserLogin: (user, pass) => dispatch(loginUserRequest(user, pass))
  };
};

export const Signin = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles)
)(withRouter(SignInComponent));

export default Signin;
